import React from "react";
import { FC } from "react";
import { ComponentProps } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { TypographyProps } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  label: {
    fontSize: 14,
    fontWeight: 400,
    color: "#bdbdbd",
    marginBottom: theme.spacing(0.25),
  },
  content: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#000",
    lineHeight: 1.71,
    display: "flex",
    alignItems: "center",
  },
}));

interface LabeledContentProps extends ComponentProps<any> {
  label: string;
  labelProps?: TypographyProps;
  childProps?: TypographyProps;
}

const LabeledContent: FC<LabeledContentProps> = ({
  label,
  labelProps,
  childProps,
  children,
  className,
  ...props
}) => {
  const classes = useStyles();
  return (
    <div {...props} className={clsx(classes.root, className)}>
      <Typography
        {...labelProps}
        className={clsx(classes.label, labelProps && labelProps.className)}
      >
        {label}
      </Typography>
      <Typography
        {...childProps}
        className={clsx(classes.content, childProps && childProps.className)}
      >
        {children}
      </Typography>
    </div>
  );
};

export default React.memo(LabeledContent);
